/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IEmployeeCategorieListItem extends Object {
        objectState: ObjectStateEnum;
    }

    class MeevoTerminatedEmployeeMoversComponent implements angular.IComponentController {

        static $inject = [];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: Object;

        public employeeCategoriesFilterList: { label: string; value: ObjectStateEnum[] }[];
        public customCriteriaObj = {};

        get securityAccessEnum() {
            return SecurityAccessEnum;
        }

        constructor() {
            this.employeeCategoriesFilterList = [
                {label: 'LABEL_ACTIVE_CATEGORIES', value: [ObjectStateEnum.Active]},
                {label: 'LABEL_INACTIVE_CATEGORIES', value: [ObjectStateEnum.Inactive]},
                {label: 'LABEL_ACTIVE_AND_INACTIVE_CATEGORIES', value: [ObjectStateEnum.Active, ObjectStateEnum.Inactive]},
            ]
        }

        public employeeCategoriesFilterFn(selectedFilterItem: { label: string; value: ObjectStateEnum[] }, row: IEmployeeCategorieListItem): boolean {
            return selectedFilterItem.value.indexOf(row.objectState) !== -1;
        }

        public onValuesChangeCallback() {
            this.customCriteriaObj = {
                IsEmployeeTerminated: this.mainModel[this.parameterNames[0]],
                HiredTerminatedStartDate: this.mainModel[this.parameterNames[0]] ? this.mainModel[this.parameterNames[1]] : null,
                HiredTerminatedEndDate: this.mainModel[this.parameterNames[0]] ? this.mainModel[this.parameterNames[2]] : null
            };
        }
    }


    angular.module('meevo.plugins.reports')
        .component('meevoTerminatedEmployeeMoversComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/meevo-terminated-employee-movers.component/meevo-terminated-employee-movers.component.html',
            controller: MeevoTerminatedEmployeeMoversComponent,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                options: '<',
            }
        });
}